<template>
    <div>

        <div v-if="init">
 
            <MarktimePreviewTable :user="user" :marktime="marktime" :approvalUser="approvalUser"></MarktimePreviewTable>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>


    </div>
</template>

<script>
import { db, auth } from '@/firebase'
import helper from '../helpers'

import MarktimePreviewTable from '@/components/MarktimePreviewTable.vue'

export default {
    data() {
        return {
            marktime: null,
            key: this.$route.params.id,
            user: null,
            approvalUser: null
        }
    },
    computed: {

        init() {
            if (this.marktime && this.user) return true
            return false
        },

    },

    components: {
        MarktimePreviewTable
    },

    methods: {

        getUser() {
            db
            .collection('users')
            .doc(this.marktime.user)
            .get()
            .then(doc => {
                this.user = doc.data()
            })

        },

        getApprovalUser() {

            if (this.marktime.approvedBy) {
                db
                .collection('users')
                .doc(this.marktime.approvedBy)
                .get()
                .then(doc => {
                    this.approvalUser = doc.data()
                })
            }

        },

        getMarktime() {
            db
            .collection('marktimes')
            .doc(this.key)
            .get()
            .then(doc => {
                
                this.marktime = helper.mutateMarktime(doc.data())

                this.getUser()
                this.getApprovalUser()
            })
        }
    },

    created() {
        this.getMarktime()
    }
}
</script>
